import { Badge } from "@/components/ui/badge";
import { priceComparison } from "./helpers";

/** "About 7.0× the current price"; renders nothing when the comparison is unknown. */
const PriceChip = ({ ratio }: { ratio: number | null | undefined }) => {
  const text = priceComparison(ratio);
  return text ? <Badge variant="outline">{text}</Badge> : null;
};

export default PriceChip;
